<div class="container-fluid wrapper-page">

    <div class="page-head">
        <h5 class="header-title text-primary pl-2 pl-md-1">PHYSICIAN'S DOCUMENTS</h5>
    </div>

    <div>
        <div class="bg-primary text-white p-1">
            <h5 class="mt-2 ml-4">UPLOAD DOCUMENTS<span class="font-italic font-size-14 ml-2">(Upto 10 documents can be
                    uploaded,File size not to exceed 2 MB)</span></h5>

        </div>
        <div class="card m-b-30">
            <div class="card-body">
                <div class="row d-flex">
                    <div class="col-md-4 text-dark">
                        <b>Enter Description</b>
                        <span class="text-danger "> * </span>
                    </div>
                    <div class="col-md-4 text-dark">
                        <b>Upload Documents</b>
                        <span class="text-danger "> * </span>
                    </div>
                </div>
                <br>
                <form [formGroup]="forms['documentsForm']">
                    <div>
                        <div class="form-group" formArrayName="documents" *ngFor="
                          let item of forms['documentsForm'].get('documents')[
                            'controls'
                          ];
                          let i = index
                        ">
                            <div class="row d-flex" [formGroupName]="i">
                                <div class="col-md-4">
                                    <input type="text" class="form-control text-dark" formControlName="description"
                                        name="description" form placeholder="Enter description "
                                        [readonly]="documents?.at(i).get('readOnly').value" />
                                    <div *ngIf="
                                documents?.at(i).get('description') &&
                                documents
                                  ?.at(i)
                                  .get('description')
                                  .hasError('required')
                              " class="invalid-feedback">
                                        This is required
                                    </div>
                                </div>
                                <div class="col-md-4" *ngIf="!documents?.at(i).get('readOnly').value">
                                    <input #inputFile class="form-control text-dark" type="file"
                                        accept="application/pdf, image/*" (change)="selectFile($event, i)"
                                        placeholder="Select file" />
                                    <div class="font-color label-text font-size-10 font-weight-400">
                                        eg. pdf, jpeg, png
                                    </div>
                                    <div *ngIf="
                                documents?.at(i).get('name') &&
                                documents?.at(i).get('name').hasError('required')
                              " class="invalid-feedback">
                                        This is required
                                    </div>
                                </div>

                                <div class="col-md-4" *ngIf="documents?.at(i).get('readOnly').value">
                                    <input class="form-control text-dark" type="text" readonly formControlName="name"
                                        name="name" />
                                </div>
                                <div class="col-md-2" *ngIf="!documents?.at(i).get('readOnly').value ">
                                    <button type="button" class="form-control btn btn-primary btn-doctor"
                                        [disabled]="!documents?.at(i).get('name').value" (click)="previewDocument(i)">
                                        Preview
                                    </button>
                                </div>

                                <div class="col-4 col-sm-2 col-md-1 m-m text-right"
                                    *ngIf="!documents?.at(i).get('readOnly').value">
                                    <button *ngIf="i >= 0" type="button" class="btn btn-outline-primary removeitem"
                                        style="padding: 12px 16px" (click)="removingCurrentDocument(i)">
                                        <i class="fa fa-close"></i>
                                    </button>
                                </div>
                                <div class="col-4 col-sm-2 col-md-1 m-m text-right"
                                    *ngIf="!documents?.at(i).get('readOnly').value">
                                    <button type="button" class="btn btn-outline-primary addmore"
                                        style="padding: 12px 16px" (click)="addingDocument(i)">
                                        <i class="fa fa-plus"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <button *ngIf="!disableSubmit" type="button" class="btn btn-primary btn-doctor pull-right"
                            [disabled]="forms['documentsForm'].invalid" (click)="saveDocuments()">Submit</button>

                    </div>
                </form>
            </div>
        </div>
    </div>


    <div class="bg-light text-dark p-1">
        <h6 class="mt-2 ml-4">Mandatory files*</h6>

        <p class="ml-5"> 1. Goverment issued photo ID Card</p>
        <p class="ml-5"> 2. Educational certificates</p>

    </div>







    <!-- <div class="chart-container">
        <canvas id="MyChart">{{ chart }}</canvas>
    </div>
 -->









































    <!--new changes -->
    <ng-template #PDFModal>
        <div>
            <div class="modal-header">
                <button type="button" class="close" (click)=closeModal()>&times;</button>
            </div>
            <div>
                <pdf-viewer [src]="pdfSrc" [render-text]="true" style="display: block;"></pdf-viewer>
            </div>
        </div>
    </ng-template>















































    <!-- 
          </div>
        </div>
      </div>
    </div>
  </div> -->